import { useCartStore } from '@/features/Cart/stores/cart';
import type { CartItemQuantity, CartRule } from '@/features/Cart/types/models';
import type { ShopifyCartItem } from '@/features/Cart/types/servicesShopifyCart';

export const cartRuleBundleMaxCartQuantity: CartRule = (cart) => {
  const { isFreeGiftItem } = useCartStore();
  const remove: CartItemQuantity[] = [];
  const update: CartItemQuantity[] = [];

  const groupsByVariant = new Map<number, ShopifyCartItem[]>();
  cart.items.forEach((item) => {
    if (isFreeGiftItem(item)) return;
    if (!item.properties?._custom_bundle_details) return;
    if (!item.properties?._max_cart_quantity) return;
    const group = groupsByVariant.get(item.variant_id) ?? [];
    group.push(item);
    groupsByVariant.set(item.variant_id, group);
  });

  groupsByVariant.forEach((items) => {
    const maxQuantity = Number(items[0].properties._max_cart_quantity);
    if (!Number.isFinite(maxQuantity) || maxQuantity <= 0) return;
    const totalQuantity = items.reduce((total, item) => total + item.quantity, 0);
    if (totalQuantity <= maxQuantity) return;

    let remaining = maxQuantity;
    items.forEach((item) => {
      if (remaining <= 0) {
        remove.push({ key: item.key, quantity: 0 });
        return;
      }
      if (remaining < item.quantity) {
        update.push({ key: item.key, quantity: remaining });
        remaining = 0;
        return;
      }
      remaining -= item.quantity;
    });
  });

  return remove.length || update.length ? { add: [], update, remove } : null;
};
